import http from '@/services/http'

export const SET_LIST_GUIA_DATA_VENCIMENTO_PADRAO = 'setListGuiaVencimentoPadrao'
export const SET_GUIA_DATA_VENCIMENTO_PADRAO_ATUALIZACAO = 'setGuiaVencimentoPadraoUp'
export const SET_GUIA_DATA_VENCIMENTO_PADRAO = 'setGuiaVencimentoPadrao'
export const SET_GUIA_DATA_VENCIMENTO_PADRAO_NEW = 'setGuiaVencimentoPadraoNew'
export const SET_GUIA_DATA_VENCIMENTO_PADRAO_REMOCAO = 'setGuiaVencimentoPadraoRemocao'
export const SET_MESSAGE_ALERT = 'setMessage'
const actions = {

    async listar_guia_vencimento_padrao(context, params) {
        await http.get(params)
            .then(response => context.commit(SET_LIST_GUIA_DATA_VENCIMENTO_PADRAO, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    async create_guia_vencimento_padrao(context, value) {
        let message = await http.post('guia-data-vencimento-padrao', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        // context.commit(SET_GUIA_DATA_VENCIMENTO_PADRAO_NEW, message.message.conteudo)
    },

    async update_guia_vencimento_padrao(context, value) {
        let message = await http.put('guia-data-vencimento-padrao/' + value.id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_GUIA_DATA_VENCIMENTO_PADRAO_ATUALIZACAO, value)
    },

    async delete_guia_vencimento_padrao(context, value) {
        let data = await http.delete('guia-data-vencimento-padrao/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, data)
        context.commit(SET_GUIA_DATA_VENCIMENTO_PADRAO_REMOCAO, value)
    },

    set_guia_vencimento_padrao(context, value) {
        context.commit(SET_GUIA_DATA_VENCIMENTO_PADRAO, value)
    }
};
const mutations = {

    [SET_MESSAGE_ALERT](state, value) {
        let customMessage = '';
        if (typeof value.message === "object") {
            if (value.message.errors) {
              Object.values(value.message.errors).map((element) => {
                    customMessage = element[0] + ' '
                })
            } else {
                customMessage = value.message.msg;
            }
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },
    [SET_LIST_GUIA_DATA_VENCIMENTO_PADRAO](state, value) {
        state.lista_guia_vencimento_padrao = value
    },
    [SET_GUIA_DATA_VENCIMENTO_PADRAO](state, value) {
        state.guia_vencimento_padrao = value
    },

    [SET_GUIA_DATA_VENCIMENTO_PADRAO_NEW](state, value) {
        state.lista_guia_vencimento_padrao.data.push(value)
    },
    [SET_GUIA_DATA_VENCIMENTO_PADRAO_ATUALIZACAO](state, value) {
        state.lista_guia_vencimento_padrao.data = state.lista_guia_vencimento_padrao.data.filter(i => i.id === value.id).map(o => Object.assign(o, value))
    },

};
const getters = {
    getGuiaVencimentoPadrao: state => {
        return state.guia_vencimento_padrao
    },
    getListaGuiaVencimentoPadrao: state => {
        return state.lista_guia_vencimento_padrao.data || []
    },
    pagination: state => {
        return state.lista_guia_vencimento_padrao.pagination || {}
    },

}

const state = {
    mensagem_alert: {},
    lista_guia_vencimento_padrao: {data:[], pagination: {}},
    guia_vencimento_padrao: {},
    empresa: {},
    faturamento: 0
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
